export default "__VITE_ASSET__BGcSoNlF__"